import useAxios from "src/core/shared/hooks/useAxios";
import {
  RequestConfig,
  UseApiRequest,
  EndpointConfig
} from "src/core/shared/api/config.api";
import { IAddress } from "src/library/components/Address";
import {
  IUser,
  IUserGroup
} from "src/core/users/api/users.api";
import {
  FilterParams,
  PaginatedData,
  PaginatedParams
} from "src/core/shared/api";

type PendingCustomerEndpointConfig = {
  GET_PENDING_CUSTOMER: EndpointConfig<
    GetPendingCustomerParams,
    IPendingCustomer
  >;
  CREATE_PENDING_CUSTOMER: EndpointConfig<
    CreatePendingCustomerParams,
    IPendingCustomer
  >;
  UPDATE_PENDING_CUSTOMER: EndpointConfig<
    UpdatePendingCustomerParams,
    IPendingCustomer
  >;
  LIST_PENDING_CUSTOMERS: EndpointConfig<
    ListPendingCustomersParams,
    PaginatedData<IPendingCustomer>
  >;
  EXPORT_PENDING_CUSTOMERS: EndpointConfig<
    ExportPendingCustomerParams,
    { message: string; }
  >;
};

/**
 * Pending Customer API
 */
const requests: RequestConfig<PendingCustomerEndpointConfig> = {
  GET_PENDING_CUSTOMER: ({ ...params }) => ({
    url: `${process.env.REACT_APP_API_URL}/core/pending-customers/${params.id}`,
    method: "GET",
    params
  }),
  CREATE_PENDING_CUSTOMER: ({ ...params }) => ({
    headers: false,
    url: `${process.env.REACT_APP_API_URL}/public/register`,
    method: "POST",
    params
  }),
  UPDATE_PENDING_CUSTOMER: ({ ...params }) => ({
    url: `${process.env.REACT_APP_API_URL}/core/pending-customers/${params.id}`,
    method: "PATCH",
    params: { id: params.id },
    data: params

  }),
  LIST_PENDING_CUSTOMERS: ({ ...params }) => ({
    url: `${process.env.REACT_APP_API_URL}/core/pending-customers`,
    method: "GET",
    params
  }),
  EXPORT_PENDING_CUSTOMERS: ({ ...params }) => ({
    url: `${process.env.REACT_APP_API_URL}/core/pending-customers/export/all`,
    method: "GET",
    params
  })
};

export enum PendingCustomerStatus {
  Pending = "pending",
  Onboarded = "onboarded",
  Rejected = "rejected"
}

export interface IPendingCustomer {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  address?: IAddress;
  status: PendingCustomerStatus;
  contactName?: string;
  contactNumber?: string;
  contactEmail?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customData?: Record<string, any>;
  exported?: boolean;
  assignedUserId?: number | null;
  assignedUser?: IUser;
  userGroupId?: number | null;
  userGroup?: IUserGroup;
}

export type GetPendingCustomerParams = { id: number };
export type CreatePendingCustomerParams = Omit<IPendingCustomer, "id" | "status" | "createdAt" | "updatedAt">;
export type UpdatePendingCustomerParams = Partial<Omit<IPendingCustomer, "status" | "createdAt" | "updatedAt">>;
export type ListPendingCustomerPagination = PaginatedParams<IPendingCustomer>;
export type ListPendingCustomerFilters = FilterParams<Partial<IPendingCustomer>>;
export type ListPendingCustomersParams = { pagination: ListPendingCustomerPagination, filters: ListPendingCustomerFilters };
export type ExportPendingCustomerParams = { filters: { status?: PendingCustomerStatus } };

export const usePendingCustomerApi: UseApiRequest<PendingCustomerEndpointConfig> = name => useAxios(requests[ name ], name);
